// React
import React from 'react';
// External
import { HiShoppingCart } from 'react-icons/hi';
import { FaDollarSign } from 'react-icons/fa';
// Internal
import PageTitle from 'components/shared/atoms/PageTitle/PageTitle';
import ShoppingCartModal from 'components/shared/organisms/ShoppingCartModal/ShoppingCartModal';
import ProductService from 'services/product';
// Styles
import './styles.scss';
import { FiChevronDown } from 'react-icons/fi';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { updateBooking } from 'stores/actions';
import isEmpty from 'lodash/isEmpty';
import Vet from 'models/Vet';

/**
 * @param {string} props.title - The text to be display as title
 * @param {Array} props.items - Array of object with the cart items.
 *                                The 'price' key is important to calculate the total
 */
class PageTitleWithCart extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            items: props.items ? props.items : [],
            shoppingCartModalOn: false,
            bookingName: '',
            vetName: localStorage.getItem('vetName')
        };
        this.setProductPrices();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.items !== this.props.items) {
            this.setState({ items: this.props.items, bookingName: localStorage.getItem('bookingName')}, () => {
                this.setProductPrices();
            });
        }
    }


    /**
     * This will update the hasSelectedBundle
     * if the product is remove from the cart
     */
    updateHasSelectedBundle() {
        if (!isEmpty(this.props.bundleLists)) {
            let hasSelectedBundle = false;
            let shouldSkip = false;
            this.props.bundleLists.forEach((bundle) => {
                if (shouldSkip) {
                    return;
                }

                let hasBundleInCart = this.props.items.find((quotedProduct) => {
                    if (quotedProduct.name === bundle.name) {
                        return true;
                    }
                });

                if (!isEmpty(hasBundleInCart)) {
                    shouldSkip = true;
                    hasSelectedBundle = true;
                    return;
                }
            })

            this.props.hasSelected(hasSelectedBundle)
        }
    }

    /**
     * Set the product prices based on the vet pricing option
     *
     * @returns {void}
     */
    async setProductPrices() {
        const items = this.state.items;

        // Get the product prices for each product and replace each product's price with it
        for (const item of items) {
            let response = await ProductService.getProductDetail(item.id, item.producttemplateIdC);
            item.unitPrice = response.data.total_product_price;
        };

        this.setState({ items: items });
    }

    getTotalPrice() {
        let total = 0.00;
        this.state.items.forEach((element) => {
            if (
                Object.hasOwnProperty.call(element, 'quantity')
                && element.quantity
                && Object.hasOwnProperty.call(element, 'unitPrice')
                && element.unitPrice
            ) {
                let strNumber = element.unitPrice
                let isUnitPriceANumber = typeof strNumber == 'string';
                let convertToInt = 0;

                if (isUnitPriceANumber) {
                    // Remove the digit after the (.)
                    let cleanNumber = strNumber.split('.')[0].replace(/,/g, "");
                    // Parse to Int
                    convertToInt = parseInt(cleanNumber.replace(/[,\.]/g, ""), 10);
                } else {
                    convertToInt = strNumber;
                }

                total += (convertToInt * element.quantity);
            }
        });

        const vet = Vet(this.props.vetDetails);

        // Add the travel costs to the total price if the pricing option is not "No Price"
        if (vet.getPricingOption() !== 'No price') {
            total += (parseFloat(this.props.booking.collection_fee) + parseFloat(this.props.booking.return_fee));
        }

        return total.toFixed(2);
    }

    openShoppingCartModal = () => {
        this.setState({ shoppingCartModalOn: true });
    }

    closeShoppingCartModal = () => {
        this.setState({ shoppingCartModalOn: false });
        this.updateHasSelectedBundle()
    }

    render() {
        return (
            <div className="page-title-cart">
                <p className='vetName'>{ this.state.vetName }</p>
                <h3 className='bookingName' style={this.props.style}>{ this.state.bookingName }</h3>
                <ShoppingCartModal
                    show={this.state.shoppingCartModalOn}
                    onHide={this.closeShoppingCartModal}
                    totalPrice={this.getTotalPrice()}
                    items={this.state.items}
                    vetDetails={this.props.vetDetails}
                />
            </div>
        );
    }
}

const mapStateToProps = (state) => ({ booking: state.booking });

const mapDispatchToProps = (dispatch) => {
    return {
        updateBooking: (bookingObj) => dispatch(updateBooking(bookingObj))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(PageTitleWithCart));
